/*jshint esversion: 6 */
import store from '@/store/index';

function Template(payload) {
  let route = {
    path: `:selected_column/${payload.step_type.toLowerCase()}cards/:${payload.step_type.toLowerCase()}_card_id`,
    name: `ProjectWallet${payload.step_type}Cards`,
    // component: () => import( /* webpackChunkName: "Project" */ '@/views/Project/ProjectWallet/ProjectWalletStepCard.view.vue'),
    component: () => import( 
       
      '@/views/Project/WorkPackageRework/WorkPackageStepsDetails.view.vue'),
    meta: {
      requiresAuth: true
    },
    props: (route) => {
      let takt_index = parseInt(route.params.takt_index);
      if (route.params.selected_column === 'right') {
        takt_index = takt_index + 1
      } else if (route.params.selected_column === 'left') {
        takt_index = takt_index - 1
      }
      return {
        // project_id: parseInt(route.params.project_id),
        step_card: store.getters[`ProjectWallet/get${payload.step_type}Card`]({
          project_id: route.params.project_id,
          takt_index: takt_index,
          id: route.params[`${payload.step_type.toLowerCase()}_card_id`]
        }),
        // step: store.state.Ultra[`t${payload.step_type.toLowerCase()}steps`][route.params[`${payload.step_type.toLowerCase()}_card_id`]],
        // comments: store.getters['WorkPackageLogList/getWorkPackageComments'],
        step_type: payload.step_type.toLowerCase(),
        location: 'ProjectWallet',
        prefix: 't',
      };
    },
    // beforeEnter: (to, from, next) => {
    //   Promise.all([
    //     store.dispatch('Ultra/requestUObject', {
    //       url: [
    //         {projects: to.params.project_id},
    //         {trains: to.params.train_id},
    //         {taktareas: to.params.taktarea_id},
    //         {twaggons: to.params.twaggon_id},
    //         {tworkpackages: to.params.tworkpackage_id},
    //         {[`t${payload.step_type.toLowerCase()}steps`]: to.params[`${payload.step_type.toLowerCase()}_card_id`]},
    //         {showWithEntitiesNormalized: ''}
    //       ]
    //     }),
    //     store.dispatch('Ultra/requestUObject', {
    //       url: [
    //         {projects: to.params.project_id},
    //         {trains: to.params.train_id},
    //         {taktareas: to.params.taktarea_id},
    //         {twaggons: to.params.twaggon_id},
    //         {tworkpackages: to.params.tworkpackage_id},
    //         {tworkpackageimages: ''},
    //         {showWithEntitiesNormalized: ''}
    //       ]
    //     }),
    //     store.dispatch('WorkPackageLogList/requestWorkPackageLogList', {
    //       project_id: to.params.project_id,
    //       train_id: to.params.train_id,
    //       taktarea_id: to.params.taktarea_id,
    //       twaggon_id: to.params.twaggon_id,
    //       twork_package_id: to.params.tworkpackage_id
    //     })
    //   ]).then(() => {
    //     next();
    //   });
    // }
  };
  if (payload && payload.children) {
    route.children = payload.children;
  }
  return route;
}
export default Template;
